import BottomFixedModal from "@src/components/common/bottomFixedModal/BottomFixedModal";

import styles from "./sortModal.module.scss";

export default function SortModal(props: {
  isOpen: boolean;
  onClose: () => void;
  menus: { value: string; text: string }[];
  selectedValue: string;
  onClickMenu: (value: string) => void;
}) {
  const { isOpen, onClose, menus, selectedValue, onClickMenu } = props;

  return (
    <BottomFixedModal isShow={isOpen} hideModal={onClose} title="" isTransition={true}>
      <div className={styles["sort-modal-content-wrap"]}>
        {menus.map((item) => (
          <button
            key={`sort-modal-menu-${item.value}`}
            className={`
              btn ${styles["menu-button"]}
              ${selectedValue === item.value ? styles["active"] : ""}
            `}
            onClick={() => {
              onClickMenu(item.value);
              onClose();
            }}
          >
            <span className={styles["text"]}>{item.text}</span>
            <div className={styles["icon-box"]}>
              <i className="icon icon-input-checked-sel" />
            </div>
          </button>
        ))}
      </div>
    </BottomFixedModal>
  );
}
